import { Box, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { HiOutlineDocument } from "react-icons/hi2";

type FileIconProps = {
  fileType: string;
  size?: "sm" | "md";
};

export const FileIcon: React.FC<FileIconProps> = ({
  fileType,
  size = "md",
}) => {
  const dimensions =
    size === "sm" ? { w: 16, h: 16 } : { w: "64px", h: "64px" };
  const iconSize = size === "sm" ? 6 : "24px";
  const fontSize = size === "sm" ? "xs" : "10px";
  const bottomOffset = size === "sm" ? 2 : "8px";

  return (
    <Box
      width={dimensions.w}
      height={dimensions.h}
      borderRadius={size === "sm" ? "sm" : "4px"}
      bg="gray.100"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="gray.700"
      flexShrink={0}
    >
      <Icon as={HiOutlineDocument} boxSize={iconSize} />
      <Text
        position="absolute"
        bottom={bottomOffset}
        left="50%"
        transform="translateX(-50%)"
        fontSize={fontSize}
        fontWeight="bold"
        color="gray.700"
        lineHeight={size === "sm" ? 3 : "12px"}
      >
        {fileType.toUpperCase()}
      </Text>
    </Box>
  );
};
